import React, { useState, useEffect, useContext} from "react"
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'
import {
  Box,
  Container,
  Button,
  Hidden,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box as BoxIcon,
} from 'react-feather';

import PageContentWrapper from "../PageContentWrapper"
import ScansContext from "../../contexts/ScansContext"

import RecruiterUserRows from "./RecruiterUserRows"

moment.locale("fr");


const RecruiterListUsers = ({ }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const splitPath = location?.pathname?.split("/")
  const lastPartOfPath = splitPath[splitPath?.length-1]

  let { id } = useParams();

  const [actScan, setActScan] = useState(null)
  const { isLoaded, scans } = useContext(ScansContext)

  const [usersList, setUsersList] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)

  useEffect(() => {
    if (lastPartOfPath === "invitees" || lastPartOfPath === "completed" || lastPartOfPath === "passed") {
      if (isLoaded === true) {
        let find = scans.find((el) => el.id === parseInt(id))
        let isPlayable = find?.playable > 0
        let content = find?.module
        if (find && isPlayable && content) {
          setActScan(find)
          if (lastPartOfPath === "invitees") {
            setUsersList(find?.userIDs)
            setDataLoaded(true)
          } else if (lastPartOfPath === "completed") {
            setUsersList(find?.completedUsers)
            setDataLoaded(true)
          } else if (lastPartOfPath === "passed") {
            setUsersList(find?.passedUsers)
            setDataLoaded(true)
          }
        } else {
          navigate('/')
          setActScan(null)
        }
      }
    }
  }, [isLoaded, actScan, id, lastPartOfPath, scans])

  const getTitle2 = (lastPartOfPath) => {
    if (lastPartOfPath === "invitees") {
      return "Invités"
    } else if (lastPartOfPath === "completed") {
      return "Complétés"
    } else if (lastPartOfPath === "passed") {
      return "Réussis"
    } else {
      return ""
    }
  }


  return (
    <PageContentWrapper
      title={actScan?.name}
      title2={getTitle2(lastPartOfPath)}
      withScanReturn
    >
      {(actScan !== null && dataLoaded === true) &&
        <Box sx={{flex:1, maxWidth:"100%", overflow:"hidden", display:"flex", flexDirection:"column", gap:["15px", "20px", "20px"]}}>
          {usersList?.length > 0 ? (
            <>
              <Box sx={{
                fontWeight:400,
                color:"text.black",
                fontSize:["14px", "15px", "16px"],
                textAlign:"right",
              }}>
                Total&nbsp;: {usersList?.length}
              </Box>
              <RecruiterUserRows
                actScan={actScan}
                userList={usersList}
              />
            </>
          ) : (
            <Box sx={{
              background:"white",
              border:"1px solid #E7E7E7",
              py : ["35px", "35px", "35px"],
              px : ["20px", "20px", "20px"],
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"20px"
            }}>
              <Box sx={{
                fontSize:["24px", "32px", "32px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Aucun candidat</Box>
            </Box>
          )}
        </Box>
      }
    </PageContentWrapper>
  )
};

export default RecruiterListUsers;
